<template>
  <div class="col-Loader">
    <div
      v-for="row in ROWS"
      :key="row.id"
      :class="{ 'col-Loader_Item-root': row.root }"
      class="col-Loader_Item"
    >
      <div
        :class="{ 'col-LoaderItem_Left-no-expand': !row.expandable }"
        class="col-LoaderItem_Left"
      >
        <SkeletonItem v-if="row.expandable" :appearance="SQUARE" :size="SM" />
        <SkeletonItem :appearance="SQUARE" :size="SM" border-radius="6px" />
        <div class="col-LoaderItem_Title">
          <SkeletonItem :size="XS" :width="row.idWidth" />
          <SkeletonItem :size="XS" :width="row.name" />
        </div>
      </div>
      <div class="col-LoaderItem_Right">
        <div class="col-LoaderItem_Interval">
          <SkeletonItem :size="XS" :width="row.interval" />
        </div>
        <div class="col-LoaderItem_Grade">
          <SkeletonItem :size="XS" :width="row.grade" />
        </div>
        <div class="col-LoaderItem_Assignee">
          <SkeletonItem :appearance="CIRCLE" :size="SM" />
        </div>
        <div class="col-LoaderItem_Checkin">
          <SkeletonItem :appearance="SQUARE" :size="SM" />
          <SkeletonItem v-if="row.checkin" :size="XS" :width="row.checkin" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  SKELETON_APPEARANCES,
  SKELETON_SIZES
} from '@/utils/components-configurations/skeleton-item'

import SkeletonItem from '@/components/ui/SkeletonLoaders/SkeletonItem'

defineOptions({
  name: 'CardObjectivesLoader'
})

const { SQUARE, CIRCLE } = SKELETON_APPEARANCES
const { SM, XS } = SKELETON_SIZES

const ROWS = [
  {
    id: 1,
    expandable: true,
    root: true,
    idWidth: '52px',
    name: '116px',
    interval: '40px',
    grade: '37px',
    checkin: '72px'
  },
  {
    id: 2,
    idWidth: '64px',
    name: '204px',
    interval: '62px',
    grade: '24px',
    checkin: '56px'
  },
  {
    id: 3,
    expandable: true,
    idWidth: '48px',
    name: '36px',
    interval: '100px',
    grade: '17px'
  },
  {
    id: 4,
    expandable: true,
    root: true,
    idWidth: '64px',
    name: '203px',
    interval: '70px',
    grade: '37px',
    checkin: '80px'
  },
  {
    id: 5,
    idWidth: '56px',
    interval: '56px',
    grade: '37px',
    name: '170px',
    checkin: '48px'
  }
]
</script>

<style lang="scss" scoped>
.col-Loader {
  padding: 0 24px;

  --checkin-header-cell-width: calc(
    var(--right-items-gap, 12px) + var(--okr-table-checkin-cell-width) +
      var(--okr-table-row-controls-button-width)
  );
}

.col-Loader_Item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  height: 44px;

  &-root {
    height: 48px;
  }
}

.col-LoaderItem_Left {
  display: flex;
  align-items: center;
  overflow: hidden;
  gap: 8px;

  &-no-expand {
    padding-left: 32px;
  }
}

.col-LoaderItem_Title {
  display: flex;
  align-items: center;
  overflow: hidden;
  gap: 4px;
}

.col-LoaderItem_Right {
  display: flex;
  align-items: center;
  gap: var(--right-items-gap, 12px);
  flex-shrink: 0;
}

.col-LoaderItem_Grade,
.col-LoaderItem_Checkin {
  display: flex;
  align-items: center;
}

.col-LoaderItem_Grade {
  width: var(--grade-header-cell-width);
  justify-content: center;
}

.col-LoaderItem_Interval {
  width: var(--ob-oeli-interval-width);
}

.col-LoaderItem_Assignee {
  width: 24px;
  display: flex;
  align-items: center;
}

.col-LoaderItem_Checkin {
  gap: 4px;
  padding-left: 5px;
  width: var(--checkin-header-cell-width);
}
</style>
